import type { GetVatInformations } from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile'
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

import translations from './TaxDetailsModal.translations'

export const VAT_MARGIN_SCHEME_VALUES: Record<
  NonNullable<GetVatInformations['vatMarginScheme']>,
  I18nDefinition
> = {
  NORMAL_VAT: translations.normalVatLabel,
  MARGIN_VAT: translations.marginVatLabel,
  MIXED_VAT: translations.mixedVatLabel,
} as const

export const OSS_DOCUMENT_TYPE = 'OSS_REGISTRATION'

export const REGEXP_VALID_VAT_NUMBER = /^[a-zA-Z]{2}[a-zA-Z0-9]{2,13}$/

export const MIN_VAT_NUMBERS_BY_COUNTRY = 1
